import { render, staticRenderFns } from "./athletics.vue?vue&type=template&id=06e04e5e&scoped=true&"
import script from "./athletics.vue?vue&type=script&lang=js&"
export * from "./athletics.vue?vue&type=script&lang=js&"
import style0 from "./athletics.vue?vue&type=style&index=0&id=06e04e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e04e5e",
  null
  
)

export default component.exports